import { Component, OnInit, EventEmitter, Input, Output, ViewEncapsulation, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FnInputValueAccessor } from '../../core/model/fn-input.value.accessor';

/**
 * This component enables the user to select and submit color values.
 * To use this FnColorPickerComponent  import FnColorPickerModule in Module.
 */
@Component({
  selector: 'fn-color-picker',
  templateUrl: 'fn-color-picker.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FnColorPickerComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class FnColorPickerComponent extends FnInputValueAccessor<any> implements OnInit {


  /**
   * Input member variable
   * Disables / hides the color input field from the dialog.
   */
  @Input() isDisableInput = true;
  /**
   * Input  member variable
   * Shows the Ok button. Saves the selected color
   */
  @Input() showOkBtn = true;
  /**
   * Input  member variable
   * Shows the Cancel button. Cancel the selected color.
   */
  @Input() showCancelBtn = true;
  /**
   * Input  member variable
   * Class to customize the OK button.
   */
  @Input() okButtonClass = 'btn btn-primary btn-xs';
  /**
   * Input  member variable
   * Class to customize the cancel button.
   */
  @Input() cancelButtonClass = 'btn btn-danger btn-xs';
  /**
   * Input  member variable
   * If true the initial color is restored when user clicks outside.
   */
  @Input() isSaveClkOutside = false;
  /**
   * Input  member variable
   * Output color format: 'auto', 'hex', 'rgba', 'hsla' ('auto').
   * default foramt is "hex"
   */
  @Input() outputFormat = 'hex';
  /**
   * Output  member function
   * callback event emitter to pass color on click OK Button.
   */
  @Output() changeColorCb: EventEmitter<string> = new EventEmitter();

  /**
   * Implements onInit event handler.
   */
  ngOnInit() {
    this.okButtonClass = this.okButtonClass + ' ok-button pull-right btn-round';
    this.cancelButtonClass = this.cancelButtonClass + ' cancel-button pull-left btn-round';
  }

  /**
   * Changes color
   * invoke on Ok button click and call onChangeColor EventEmitter.
   * @param colorCode  color code string value
   */
  changeColor(colorCode: string) {
    this.value = colorCode;
    this.changeColorCb.emit(colorCode);
  }
}
